export default __webpack_public_path__ + "static/media/anna.cb63136c.png";